import React, { Dispatch, SetStateAction } from "react";
import { useMessageSource } from "react-message-source";
import { Dialog } from "@mui/material";
import TypographyItemContainer from "../../../../ui/layout/page/typography-container/typography-item-container";
import CustomTypography from "../../../../ui/widgets/typography";
import Button from "../../../../ui/widgets/button";

interface ExistingApplicationFoundProps {
  isModalOpen: boolean;
  setNotifyExistingApplication: Dispatch<SetStateAction<boolean>>;
}

const classNameBase = "scd-dialog";

const ExistingApplicationFoundModal: React.FC<
  ExistingApplicationFoundProps
> = ({
  isModalOpen,
  setNotifyExistingApplication,
}: ExistingApplicationFoundProps) => {
  const { getMessage } = useMessageSource();

  const handleButtonClick = (): void => {
    setNotifyExistingApplication(false);
  };

  return (
    <>
      <Dialog
        disableEscapeKeyDown={false}
        fullWidth
        maxWidth="xl"
        aria-labelledby="confirmation-dialog-title"
        open={isModalOpen}
        classes={{
          root: `${classNameBase}`,
          paper: `${classNameBase}-paper`,
          container: `${classNameBase}-container`,
        }}
      >
        <TypographyItemContainer>
          <CustomTypography variant="h2">
            {getMessage("ExistingApplication.title")}
          </CustomTypography>
        </TypographyItemContainer>

        <TypographyItemContainer>
          <CustomTypography variant="body1">
            {getMessage("ExistingApplication.sub-title")}
          </CustomTypography>
        </TypographyItemContainer>

        <div className={`${classNameBase}-footer`}>
          <Button onClick={handleButtonClick} kind="primary">
            {getMessage("Onboarding.continue")}
          </Button>
        </div>
      </Dialog>
    </>
  );
};

export default ExistingApplicationFoundModal;
